import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
         const name = location.pathname;
            if (name==='/')
                document.title = 'گشتالت';
            else if (name==='/login')
                document.title = 'گشتالت | ورود';
            else if (name==='/register')
                document.title = 'گشتالت | ثبت نام';
            else if (name==='/verifyOTP')
                document.title = 'گشتالت | فعالسازی';
            else if (name==='/panel')
                document.title = 'گشتالت | خانه';
            else if (name==='/users')
                document.title = 'گشتالت | کاربران';
            else if (name==='/exams')
                document.title = 'گشتالت | ازمون ها';
            else if (name.startsWith('/exam/'))
                document.title = 'گشتالت | ازمون';
            else if (name==='/FutureExams')
                document.title = 'گشتالت | ازمون های پیش رو';
            else if (name==='/PastExams')
                document.title = 'گشتالت | ازمون های قبلی';
            else if (name==='/Results' || name==='/Reports')
                document.title = 'گشتالت | کارنامه ها';
            else if (name.startsWith('/Result/') || name.startsWith('/ResultById/'))
                document.title = 'گشتالت | کارنامه';
            else if (name.startsWith('/Videos/'))
                document.title = 'گشتالت | ویدیو';
            else if(name==='/ExamTaker')
                document.title = "گشتالت | آزمون";
            else
                document.title = 'گشتالت';

    }, [location]);

    return null; // This component doesn't render anything
};

export default TitleUpdater;
